module.exports = __webpack_public_path__ + "img/about_year_2019.775ec4cc.png";